/*----------------------------------
- DEPENDANCES
----------------------------------*/

// Npm
import Cookie from 'js-cookie';

// Core
import ClientApplication from '@client/app';
import type { CoreError } from '@common/errors';

// Core Services
import Router from '@client/services/router';

// App Services
import MetricsService from '@/client/services/metrics';

/*----------------------------------
- TYPES
----------------------------------*/

const AFFILIATE_LINK_QUERY_KEY = 'affiliateLink';
const AFFILIATE_LINK_COOKIE_KEY = 'affiliateLinkId';
const AFFILIATE_LINK_COOKIE_TTL_DAYS = 90;

const persistAffiliateLinkFromUrl = (): void => {
    if (typeof window === 'undefined') {
        return;
    }

    const searchParams = new URLSearchParams(window.location.search);
    const affiliateLinkCode = searchParams.get(AFFILIATE_LINK_QUERY_KEY)?.trim();
    if (!affiliateLinkCode) {
        return;
    }

    Cookie.set(AFFILIATE_LINK_COOKIE_KEY, affiliateLinkCode, {
        expires: AFFILIATE_LINK_COOKIE_TTL_DAYS,
        sameSite: 'lax',
    });
};

/*----------------------------------
- APPLICATION
----------------------------------*/
export class CrossPath extends ClientApplication {

    public Router = new Router(this, {
        preload: [],

        context: (context, router) => ({
            user: context.user || router.ssrContext.user
        })
    })

    public metrics = new MetricsService(this);

    public boot(): void {
        // Persist affiliate attribution when landing with `?affiliateLink=:code`.
        persistAffiliateLinkFromUrl();

        // Tracking
        this.Router.on('page.changed', () => {
            persistAffiliateLinkFromUrl();
            this.metrics.event('pageview');
        });

        // Open pgrade modal
        this.Router.on('page.rendered', () => {

           
        });
    }

    public handleError(error: CoreError) {

        const message = ('render' in error && error.render) ? error.render() : error.message;
        this.toast.error( message, undefined, null, { autohide: false });
    }
}

export default CrossPath
